import React from 'react';
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import Button from '@material-ui/core/Button';
import Colors from '../utils/colors';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    createButton: {
        backgroundColor: Colors.lightBlue,
        "&:hover": {
            backgroundColor: 'rgba(110, 247, 138, 0.33)',
            color: Colors.indigoBlue
          },
        marginTop: '1rem',
        marginBottom: '1rem',
        paddingTop: '0.75rem',
        paddingBottom: '0.75rem',
    },
    normalCase: {
        textTransform: 'none'
    } 
}));

export default function CreateButton({ onClick, children, normalCase, ...props }) {
    const classes = useStyles();
    let buttonClass = `${classes.createButton}`;
    if (normalCase) {
        buttonClass += ` ${classes.normalCase}`;
    }

    return (
        <Button {...props}
            className={buttonClass}
            startIcon={(<AddCircleOutlineIcon/>)}
            onClick={onClick}
            fullWidth>
            {children}
        </Button>
    );
}